import { render, staticRenderFns } from "./commonStudy.vue?vue&type=template&id=5d26ecd0&scoped=true"
import script from "./commonStudy.vue?vue&type=script&lang=js"
export * from "./commonStudy.vue?vue&type=script&lang=js"
import style0 from "./commonStudy.vue?vue&type=style&index=0&id=5d26ecd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d26ecd0",
  null
  
)

export default component.exports